<router-outlet (activate)="onActivate($event)" *ngIf="isClientAuthorized"></router-outlet>
<app-application-client-access-form *ngIf="isClientAuthorized === false"></app-application-client-access-form>
